import styled, { DefaultTheme } from 'styled-components';

type Props = {
  color?: keyof DefaultTheme['colors'];
  disabled?: boolean;
};

export const Wrapper = styled.span<Props>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  svg.icon-fill {
    fill: ${({ theme, color }) => (color ? theme.colors[color] : '')};
  }
`;
